import { lazy, Suspense } from "react"

import { SkeletonsBlock } from "@/molecules/SkeletonsBlock"

import type { FixesLocationCardComponent } from "."

const Card = lazy(() =>
  import("./Card").then((module) => ({
    default: module.FixesLocationCard
  }))
)

export const FixesLocationCard: FixesLocationCardComponent = (props) => {
  return (
    <Suspense fallback={<SkeletonsBlock />}>
      <Card {...props} />
    </Suspense>
  )
}
